export default __webpack_public_path__ + "static/media/quoridor.78d3b179.PNG";